
import { getGuessStatuses } from './statuses'
import { GAME_TITLE } from '../constants/strings'
import { getStoredIsHighContrastMode, loadGameScoreFromLocalStorage, saveGameScoreToLocalStorage } from './localStorage'
import { MAX_CHALLENGES } from '../constants/settings'

declare global {
  interface Window { hurdle_score: number; }
}

export const generateStatus = (
  guesses: string[],
  lost: boolean,
  isHardMode: boolean,
  currentStep: number,
  isFinal: boolean,
  words: any
) => {
 return `${isFinal ? "Final " : ""} ${
      lost ? 'X' : isFinal ? guesses.length === 5 ? 1 : 2 : guesses.length
    }/${isFinal ? 2 : MAX_CHALLENGES}${isHardMode ? '*' : ''}\n` +
      generateEmojiGrid(words, guesses, currentStep, isFinal, isHardMode) + `\n`
}

export const calculateHurdleScore = (numGuesses: number, numGreenSquares: number, isHardMode: boolean) => {
  let currentScore = loadGameScoreFromLocalStorage();
  let hurdleTotal = 700 - (100 * numGuesses) + (10 * numGreenSquares);
  if (isHardMode) {
    hurdleTotal += 50;
  }
  saveGameScoreToLocalStorage(currentScore + hurdleTotal);
  window.hurdle_score =  window.hurdle_score + hurdleTotal;

};

export const calculateFinalHurdleScore = (numGuesses: number, isHardMode: boolean) => {
  let currentScore = loadGameScoreFromLocalStorage();
  let finalHurdleTotal = 750 - (250 * numGuesses);
  if (isHardMode) {
    finalHurdleTotal += 50;
  }
  saveGameScoreToLocalStorage(currentScore + finalHurdleTotal);
  window.hurdle_score =  window.hurdle_score + finalHurdleTotal;
};

export const shareStatus = (
  guesses: string[],
  status: string,
  lost: boolean,
  isHardMode: boolean,
  currentStep: number,
  words: any,
  solutionIndex: string
) => {
  navigator.clipboard.writeText(
    `${GAME_TITLE} ${solutionIndex}\nhttps://hurdle.games \n\n` +  
    `${status}`
  )
}

export const generateEmojiGrid = (words: any, guesses: string[], currentStep: number, isFinal: boolean, isHardMode: boolean) => {
  let numGreenSquares = 0;
  let _guesses = guesses
    .map((guess) => {
      const status = getGuessStatuses(words, guess, currentStep)
      const isHighContrast = getStoredIsHighContrastMode()
      return guess
        .split('')
        .map((_, i) => {
          switch (status[i]) {
            case 'correct':
              // if (isHighContrast) {
              //   return '🟧'
              // }
              numGreenSquares+=1;
              return '🟩'
            case 'present':
              // if (isHighContrast) {
              //   return '🟦'
              // }
              return '🟨'
            default:        
              return '⬜'
          }
        }).join('');

    })

    if (isFinal) {
      _guesses = _guesses.slice(4, 6);
    }
    
    if (isFinal) {
      calculateFinalHurdleScore(guesses.length - 4, isHardMode);
    } else {
      calculateHurdleScore(guesses.length, numGreenSquares, isHardMode);
    }
    
   return _guesses.join("\n");
}
